import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/svgs/dots_gray.svg'
import _imports_1 from '@/assets/svgs/logout.svg'


const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "flex flex-col flex-grow bg-background" }
const _hoisted_3 = { class: "container pt-8" }
const _hoisted_4 = { class: "flex flex-row items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Back")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "flex flex-row items-start mt-8"
}
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col flex-grow card-main"
}
const _hoisted_9 = { class: "relative flex flex-row items-center justify-between" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_11 = {
  key: 0,
  class: "bg-blue-100 runded p-2 text-sm rounded mr-2"
}
const _hoisted_12 = { class: "text-blue-500" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5 text-primary",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Sync with Nomilinea")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "bg-red-200 rounded px-4 py-2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "Dismissed", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 3,
  class: "flex flex-row items-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "bg-yellow-200 rounded px-4 py-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Dismissal in progress")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Finish dismissal")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add Employee Id")
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  ref: "openMenu",
  class: "absolute right-0 top-0 mt-4 bg-white rounded shadow"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4 font-semibold" }, "End contract")
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"px-4 py-4\"><div class=\"flex flex-row items-center\"><img src=\"" + _imports_1 + "\"><span class=\"ml-4 font-semibold\">End contract</span></div></div><div class=\"bg-primary-light rounded p-2 mx-2\"><span> Are you sure you want to end <br> this talent&#39;s contract? <br> This action cannot be undone. </span></div>", 2)
const _hoisted_32 = { class: "flex flex-row justify-end my-4 mr-2" }
const _hoisted_33 = { class: "flex flex-col" }
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = { class: "flex flex-row items-start" }
const _hoisted_36 = {
  key: 0,
  class: "flex flex-row items-center text-sm text-gray-500 ml-4"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Entry date", -1)
const _hoisted_38 = {
  key: 0,
  class: "bg-background p-2 rounded ml-2"
}
const _hoisted_39 = {
  key: 1,
  class: "flex flex-row items-center text-sm text-gray-500 ml-4"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "Dismissal date", -1)
const _hoisted_41 = {
  key: 0,
  class: "bg-background p-2 rounded ml-2"
}
const _hoisted_42 = { class: "bg-background p-2 rounded text-sm text-gray-500 ml-4" }
const _hoisted_43 = { class: "flex flex-col text-sm text-gray-500 ml-16" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 2,
  class: "flex flex-row items-center"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "PTO days", -1)
const _hoisted_48 = { class: "bg-background p-2 rounded ml-2" }
const _hoisted_49 = { class: "flex flex-col" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", null, "Contact info", -1)
const _hoisted_51 = { class: "flex flex-row" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"w-6 mr-2\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-5 w-5\" viewBox=\"0 0 20 20\" fill=\"currentColor\"><path d=\"M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z\"></path><path d=\"M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z\"></path></svg></div><div class=\"w-32\"><span>Job email</span></div>", 2)
const _hoisted_54 = { class: "text-black" }
const _hoisted_55 = { class: "flex flex-row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "w-6 mr-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
      "clip-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "w-32" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Personal email")
], -1)
const _hoisted_58 = { class: "text-black" }
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-row\"><div class=\"w-6 mr-2\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-5 w-5\" viewBox=\"0 0 20 20\" fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z\" clip-rule=\"evenodd\"></path></svg></div><div class=\"w-32\"><span>Address</span></div><span class=\"text-black\">Address, address, Mexico</span></div><div class=\"flex flex-row\"><div class=\"w-6 mr-2\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-5 w-5\" viewBox=\"0 0 20 20\" fill=\"currentColor\"><path d=\"M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z\"></path></svg></div><div class=\"w-32\"><span>Phone</span></div><span class=\"text-black\">123456789</span></div>", 2)
const _hoisted_61 = { class: "flex flex-row items-center mt-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", null, "Skills:", -1)
const _hoisted_63 = { class: "flex flex-row text-center items-center justify-evenly mt-8" }
const _hoisted_64 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_TalentDetailSidebar = _resolveComponent("TalentDetailSidebar")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_Onboarding = _resolveComponent("Onboarding")!
  const _component_Position = _resolveComponent("Position")!
  const _component_PaymentBreakdown = _resolveComponent("PaymentBreakdown")!
  const _component_PaymentInformation = _resolveComponent("PaymentInformation")!
  const _component_AddNomilineaId = _resolveComponent("AddNomilineaId")!
  const _component_ModalOffboarding = _resolveComponent("ModalOffboarding")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/talent'))),
            class: "btn-outline-lg"
          }, _hoisted_6)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : (_ctx.error)
            ? (_openBlock(), _createBlock(_component_ErrorState, { key: 1 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_TalentDetailSidebar, { class: "w-96" }),
                (_ctx.talent.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.talent.tasks)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              (
                    _ctx.talent.tasks.completed > 0 &&
                    _ctx.talent.tasks.completed !== _ctx.talent.tasks.total
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("span", _hoisted_12, " Onboarding " + _toDisplayString(_ctx.talent.tasks.completed) + " of " + _toDisplayString(_ctx.talent.tasks.total), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.talent.status === 'hired')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn-text ml-4",
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.syncTalentWithNomilinea && _ctx.syncTalentWithNomilinea(...args)))
                                  }, _hoisted_14))
                                : (_ctx.talent.status === 'dismissed')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                                  : (_ctx.talent.status === 'dismissal_in_progress')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _hoisted_19,
                                        _createElementVNode("button", {
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModalOffboarding = true)),
                                          class: "btn-text ml-4"
                                        }, _hoisted_21)
                                      ]))
                                    : (!_ctx.talent.nomilinea_profile)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 4,
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal = true)),
                                          class: "btn-text ml-4"
                                        }, _hoisted_23))
                                      : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.talent.status !== 'dismissed')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showMenu = true))
                            }, _hoisted_25))
                          : _createCommentVNode("", true),
                        (_ctx.showMenu)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              (!_ctx.showConfirmation)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showConfirmation = true)),
                                    class: "px-4 py-4 hover:bg-gray-100 rounded"
                                  }, _hoisted_28))
                                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _hoisted_30,
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("button", {
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModalOffboarding = true)),
                                        class: "btn-filled-sm"
                                      }, " Continue ")
                                    ])
                                  ]))
                            ], 512))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_Divider, { marginY: "4" }),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_UserCard, {
                              firstName: _ctx.talent.first_name,
                              lastName: _ctx.talent.last_name,
                              position: _ctx.talent.job_title
                            }, null, 8, ["firstName", "lastName", "position"]),
                            (_ctx.talent.status !== 'dismissed')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _hoisted_37,
                                  (_ctx.talent.entry_day)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _createVNode(_component_DateFormatter, {
                                          date: _ctx.talent.entry_day
                                        }, null, 8, ["date"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _hoisted_40,
                                  (_ctx.talent.baja_fecha)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                        _createVNode(_component_DateFormatter, {
                                          date: _ctx.talent.baja_fecha
                                        }, null, 8, ["date"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])),
                            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.talent.Empleado_ID), 1)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            (_ctx.talent.company)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.talent.company.visible_name), 1))
                              : _createCommentVNode("", true),
                            (_ctx.talent.salary)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, " $" + _toDisplayString((_ctx.talent.salary.biweekly / 100).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })) + " (MXN) ", 1))
                              : _createCommentVNode("", true),
                            (_ctx.talent.pto)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.talent.pto.balance) + "/" + _toDisplayString(_ctx.talent.pto.max_balance), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_49, [
                              _hoisted_50,
                              _createElementVNode("div", _hoisted_51, [
                                _hoisted_52,
                                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.talent.email), 1)
                              ]),
                              _createElementVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _hoisted_57,
                                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.talent.email), 1)
                              ]),
                              _hoisted_59
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talent.skills, (skill, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: "bg-primary-light text-primary rounded p-2 ml-2"
                                }, _toDisplayString(skill), 1))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, i) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: i,
                            class: _normalizeClass(["capitalize font-medium mx-2", {
                  'text-gray-400': !item.selected,
                  'text-black font-semibold': item.selected,
                }]),
                            onClick: ($event: any) => (_ctx.$router.push(`/talent/${_ctx.talent.id}/${item.name}`))
                          }, _toDisplayString(item.name.replaceAll("-", " ")), 11, _hoisted_64))
                        }), 128))
                      ]),
                      _createVNode(_component_Divider, { marginY: "4" }),
                      (_ctx.subpage === 'timeline')
                        ? (_openBlock(), _createBlock(_component_Onboarding, {
                            key: 0,
                            user_id: _ctx.talent.id,
                            status: _ctx.talent.onboarding_status
                          }, null, 8, ["user_id", "status"]))
                        : _createCommentVNode("", true),
                      (_ctx.subpage === 'role' && _ctx.talent.status !== 'inactive')
                        ? (_openBlock(), _createBlock(_component_Position, {
                            key: 1,
                            talent: _ctx.talent
                          }, null, 8, ["talent"]))
                        : _createCommentVNode("", true),
                      (_ctx.subpage === 'payment-breakdown')
                        ? (_openBlock(), _createBlock(_component_PaymentBreakdown, {
                            key: 2,
                            refreshPage: _ctx.refreshPage,
                            "onUpdate:refreshPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.refreshPage) = $event)),
                            talent: _ctx.talentAndMeta
                          }, null, 8, ["refreshPage", "talent"]))
                        : _createCommentVNode("", true),
                      (
                _ctx.subpage === 'payment-information' &&
                _ctx.talent.job &&
                _ctx.talent.status !== 'inactive'
              )
                        ? (_openBlock(), _createBlock(_component_PaymentInformation, {
                            key: 3,
                            nomilinea: _ctx.talent.nomilinea_profile,
                            id: _ctx.talent.id,
                            department: _ctx.talent.job.department,
                            department_id: _ctx.talent.job.department_code,
                            entry_day: "2021-01-01",
                            job_title: _ctx.talent.job_title
                          }, null, 8, ["nomilinea", "id", "department", "department_id", "job_title"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
      ])
    ]),
    _createVNode(_component_AddNomilineaId, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.openModal) = $event)),
      refreshPage: _ctx.refreshPage,
      "onUpdate:refreshPage": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.refreshPage) = $event)),
      user_id: _ctx.$route.params.id
    }, null, 8, ["openModal", "refreshPage", "user_id"]),
    _createVNode(_component_ModalOffboarding, {
      openModal: _ctx.openModalOffboarding,
      "onUpdate:openModal": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.openModalOffboarding) = $event)),
      talent_id: _ctx.talent.id,
      talent_name: `${_ctx.talent.first_name} ${_ctx.talent.last_name}`,
      company_id: _ctx.talent.company?.id
    }, null, 8, ["openModal", "talent_id", "talent_name", "company_id"])
  ]))
}